import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const WCConfig: BetQLSportItem = {
  id: "936586fd-075d-4e21-844a-935a69fe249d",
  name: "World Cup",
  url: "soccer-world-cup",
  tabName: "World Cup",
  icon: "soccer",
  imagePath: "WC",
  key: "WC",
  lookupKey: "wc",
  favoriteLine: "moneyline",
  isSoccer: true,
  hasTeamPowerProjectionGrades: false,
  hasFGspreadPowerRating: false,
  hasFGmoneylinePowerRating: false,
  hasFGtotalPowerRating: false,
  has1HspreadPowerRating: false,
  has1HmoneylinePowerRating: false,
  has1HtotalPowerRating: false,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: true,
  hasInjuries: false,
  hasNews: false,
  hasLineup: false,
  hasSchedule: false,
  hasConfiguredSchedule: true,
  hasTeamSummary: false,
  hasGameFilters: false,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: false,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: false,
  hasDraws: true,
  hasSharpData: false,
  hasTopTrendsData: false,
  hasPlayerProps: false,
  hasRecommendedBets: false,
  hasPopularEvents: false,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,4,9,5,14]}',
  defaultColumnOrder: [2, 4, 9, 5, 14],
  publicThreshold: 60,
  sharpPercentThreshold: 20,
  sharpCountThreshold: 500,
  publicCountThreshold: 500,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline",
    },
    {
      name: "Total",
      key: "total",
      url: "over-unders",
    },
    {
      name: "Spread",
      key: "spread",
      url: "spread",
    },
    {
      name: "1st Half Moneyline",
      key: "1Hmoneyline",
      url: "first-half-moneyline",
    },
    {
      name: "1st Half Spread",
      key: "1Hspread",
      url: "first-half-lines",
    },
    /* {
      name: "2nd Half Moneyline",
      key: "2Hmoneyline",
      url: "second-half-moneyline",
    },
    {
      name: "2nd Half Spread",
      key: "2Hspread",
      url: "second-half-line",
    }, */
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["moneyline", "total", "spread", "1Hmoneyline", "1Hspread" /*, "2Hmoneyline", "2Hspread"*/],
};

export default WCConfig;
